import React, { useEffect, useState, useCallback, useRef } from "react";
import Carduser from "./carduser";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getAccount ,savedatauser} from "./../../services/fire";
import Toggle from "../common/toggle";
import dlv from "dlv";
import { useForm } from "react-hook-form";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import Note from "./note";
import { toast } from "react-toastify";
const Modaladduser = ({
  button1,
  isOpen,
  header,
  onCancel,
  onconfirm,
  value,
  list,
}) => {
  let status;
  try {
    const ojb1 = value;
    status = dlv(ojb1, "status", true);
  } catch {}
  let editid;
  let name;
  let empid;
  try {
    const ojb = list[0];
    editid = dlv(ojb, "_id", "0");
    name = dlv(ojb, "name", "");
    empid = dlv(ojb, "empid", "");
  } catch {}
  const PreloadedValues = {
    id: editid,
    item: name,
    empid: empid,
  };

  const [error, seterror] = useState("");
  const [autoid, setautoid] = useState(0);
  const [pempid, setpempid] = useState("");
  const [disable, setdisable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [equipmentid, setequipmentid] = useState(0);
  const [searchuser, setsearchuser] = useState("");
  const [datalist, setdatalist] = useState([]);
  const [enabled, setenabled] = useState(true);
  const [nowDate, setNowDate] = useState(new Date());
  const [openUpload, setopenUpload] = useState(false);
  const [notes, setNotes] = useState([]);
  const [search, setsearch] = useState("");
  const [toggle, settoggle] = useState({
    nonpower: { isChecked: false, text: "สิทธิ์ Non Power" },
    powergroup: { isChecked: false, text: "สิทธิ์ กลุ่มPower" },
  });

  const { register, errors, handleSubmit, setValue } = useForm({
    mode: "onSubmit",
    //  defaultValues: PreloadedValues,
  });

  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });
  useEffect(() => {
     setdatalist([]);
     setsearchuser("")
     setNotes([])
  }, [isOpen]);

  useEffect(() => {
    if (list > 0) {
      settoggle({
        nonpower: { isChecked: list[0].nonpower, text: "สิทธิ์ Non Power" },
        powergroup: {
          isChecked: list[0].powergroup,
          text: "สิทธิ์ กลุ่มPower",
        },
      });
    }
  }, [list]);

  useEffect(() => {
    setdisable(!status);
  }, [status]);

  const handleChangeToggle = (e) => {
    const { id, checked } = e.target;
    const name = toggle[id].text;
    const Id = {
      text: name,
      isChecked: checked,
    };
    settoggle((prevToggle) => {
      return {
        ...prevToggle,
        [id]: Id,
      };
    });
  };
  const handleEmpChange = (event) => {
    setsearchuser(event.target.value);
  };
  //console.log("youclik", searchuser);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearch(name);
      setPageNumber(1);
    }
  };

  const handleSearchClick = (e) => {
    const loadData = async () => {
      const { data: result } = await getAccount(searchuser);
      if (result.status === "success") {
        setdatalist(result.data.list);
      }
    };
  
    loadData();
  };

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
       //console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );
  const handleOnClick = (event) => {    
    // console.log("event",event)
    const found = notes.find((item) => item.empid === event[0]);
    if (!found) {
      addNote({
        empid: event[0],
        Pulp: event[2],
        power: event[1],
      });
    }
 
  };

  function addNote(newNote) {
    setNotes((prevNotes) => {
      return [...prevNotes, newNote];
    });
  }

  const onSubmit = (data) => {
    seterror("");

    const saveobject = {
      id: autoid,

      groupid: equipmentid,
      disable: disable,
      ...data,  
    };
    SaveData(saveobject);
  };

  const SaveData = async (doc) => {

  };

  function deleteNote(id) {
    setNotes((prevNotes) => {
      return prevNotes.filter((noteItem, index) => {
        return index !== id;
      });
    });
  }
  const handleTextchange = () => {
    setdisable(!disable);
  };
//   const handleonsave = (doc) => {

// console.log("docaaaa",doc)

//   };
  const handleonsave = async (doc) => {

    const { data: result } = await savedatauser(doc);

    if (result.status == "success") {
      toast.success("บันทึกเรียบร้อยค่ะ");
      onCancel(false)
    } else {
       toast.error(result.message);
    }
  };
  const handleKeyPressuser = (event) => {
    if (event.key === "Enter") {
      if (searchuser !== "") {
        const loadData = async () => {
          const { data: result } = await getAccount(searchuser);

          if (result.status === "success") {
            setdatalist(result.data.list);
          }
        };

        loadData();
      }
    }
  };

  const handleChangeToggleCustom = (empid, name, value) => {
    const sublist = [...datalist];
    const index = sublist.findIndex((x) => x.empid === empid);
    const subobject = sublist[index];
    let editobject;
    if (name === "power") {
      editobject = { ...subobject, power: !value };
    } else {
      editobject = { ...subobject, pulp: !value };
    }
    sublist[index] = editobject;
    setdatalist(sublist);
    
  };

  return (
    <>
      <div>
        <Modal
          isOpen={isOpen}
          toggle={onCancel}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ModalHeader>
            <FontAwesome name="pencil-square-o"> </FontAwesome> {header}
            เพิ่มผู้ใช้
          </ModalHeader>
          <ModalBody>
            <div className="row col-lg-6 col-sm-6 col-xs-12 mb-3">
              <div className="input-group ">
                <Input
                  label="ชื่อ รหัสพนักงาน"
                  value={searchuser}
                  onChange={handleEmpChange}
                  onKeyPress={handleKeyPressuser}
                  onClick={handleSearchClick}
                  placeholder="รหัส/ชื่อ เพื่อค้นหา"
                  search="ค้นหา"
                />
              </div>
            </div>

            <Carduser
              list={datalist}
              handleChangeToggleCustom={handleChangeToggleCustom}
              handleOnClick={handleOnClick}
              // handleChangeToggle3 ={handleChangeToggle3}
              error={error}
              lastBookElementRef={lastBookElementRef}
              search={true}
            />
          </ModalBody>
          {
            <div>
              <div className="row">
                <div className="col-12">
                  <div className="card mb-2">
                    <div className="card-body p-2">
                      <div className="row ms-2">
                        <div className="col">
                          <div className="row ms-2">
                            <div className="col">
                              {notes.map((noteItem, index) => {
                                return (
                                  <Note
                                    key={index}
                                    id={index}
                                    title={noteItem.empid}
                                    empid={noteItem.empid}
                                    onDelete={deleteNote}
                                  />
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {error && (
            <div className="col-md-12 alert alert-danger"> {error}</div>
          )}

          {list && list.comment && (
            <Button color="danger">{list.comment}</Button>
          )}
          <ModalFooter>
            <Button color="primary" 
            disabled ={notes && notes.length > 0 ? false :true}
             onClick={() => handleonsave(notes)} >
              
              บันทึก
            </Button>
            <Button color="secondary" onClick={onCancel}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default Modaladduser;
